import { colors } from '@insurancemenu/imenu-components-lib';
import { boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';
import { createUseStyles } from 'react-jss';

const styles = {
  content: {
    paddingBottom: '5rem',
    maxWidth: '170rem',
    margin: '0 auto',
  },
  dateRange: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  actionHeader: {
    display: 'flex',
    gap: '3rem',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    marginBottom: '8rem',
    '@media(max-width:1350px)': {
      justifyContent: 'center',
    },
  },
  filters: {
    display: 'flex',
    gap: '3rem',
    alignItems: 'center',
  },
  // Table
  tableWrapper: {
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    maxWidth: '170rem',
    margin: '0 auto',
    boxShadow: boxShadows.dark[4],
    overflow: 'hidden',
  },
  table: {
    width: 'max(100%, 108rem)',
  },
  tableBody: {
    boxSizing: 'border-box',
  },
  tableHeader: {
    boxSizing: 'border-box',
  },
  tableHeading: {
    padding: '1.6rem 0.5rem',
    width: '3rem',
    '&:first-child': {
      width: '2rem',
      paddingLeft: '2.4rem',
    },
    '&:last-child': {
      paddingRight: '2.4rem',
    },
  },

  buttonCell: {
    width: '3.2rem',
  },
  infoTitle: {
    margin: '0 0 2rem',
    fontSize: '1.6rem',
    textAlign: 'right',
  },
  totalAmount: {
    marginLeft: '1rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
